var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 161,
    height: 240,
    viewBox: "0 0 161 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M80.5,76.75c-23.85,0-43.25,19.4-43.25,43.25,0,9.22,2.91,17.77,7.85,24.8l60.2-60.2c-7.02-4.94-15.57-7.85-24.8-7.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M55.7,155.41c7.03,4.94,15.58,7.85,24.8,7.85,23.85,0,43.26-19.41,43.26-43.26,0-9.22-2.91-17.77-7.85-24.8l-60.21,60.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,0V240H161V0H0ZM80.5,178.26c-15.76,0-30.07-6.31-40.57-16.52-.21-.17-.42-.35-.62-.55-.2-.19-.38-.4-.55-.61-10.21-10.5-16.51-24.81-16.51-40.58,0-32.12,26.13-58.25,58.25-58.25,15.77,0,30.08,6.3,40.58,16.51,.21,.17,.42,.35,.62,.55,.19,.2,.37,.4,.54,.62,10.21,10.49,16.52,24.81,16.52,40.57,0,32.12-26.13,58.26-58.26,58.26Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.538c90cab4718c04dc2ca5baf04fcb7a.svg";
export { ForwardRef as ReactComponent };